@keyframes gradientAnimation {
  0% {
    background-position: 0% 50%;
  }

  100% {
    background-position: 200% 50%;
  }
}

@keyframes widthGrow {
  0% {
    width: 0%;
  }

  100% {
    width: 100%;
  }
}

.gradientBar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(
    90deg,
    #9eb1ff,
    #3e63dd,
    #ff92ad,
    #e93d82,
    #29ffdc,
    #0eb39e,
    #9eb1ff
  );
  background-size: 200% 200%;
  animation: gradientAnimation 3s linear infinite;
  animation-play-state: var(--gradient-bar-play-state, running);
  z-index: 2;
  pointer-events: none;
}

.progressGradientBar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: auto;
  width: 0%;
  background: linear-gradient(
    90deg,
    #9eb1ff,
    #3e63dd,
    #ff92ad,
    #e93d82,
    #29ffdc,
    #0eb39e,
    #9eb1ff
  );
  background-size: 200% 200%;
  animation:
    widthGrow var(--gradient-bar-duration, 10000ms) linear infinite,
    gradientAnimation 3s linear infinite;
  animation-play-state: var(--gradient-bar-play-state, running);
  z-index: 2;
  pointer-events: none;
}
